import { NgClass } from '@angular/common'
import { Component, input } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'
import { BndButton } from '@bonduelle-it/storybook'

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  imports: [MatIconModule, BndButton, NgClass],
})
export class ActionComponent {
  /**
   * @deprecated Use iconSrc instead
   * This was the legacy property that was using the svgIcon property from the matetial icon set
   */
  readonly svgIcon = input<string>()

  readonly primeIcon = input<string>()

  readonly size = input<number>()
}
